import Notification from '@components/Notification';
import { Text, Button } from '@simplywallst/ui-core';
import { useResendEmailValidation } from '@/hooks/useResendEmailValidation';
import { useAuthErrorMessage } from './useAuthErrorMessage';
import { useDispatch } from 'react-redux';
import { redirect } from 'redux-first-router';
import { ROUTE_USER_REGISTER } from '@/constants/routes';

interface Props {
  error: unknown;
  email?: string;
  selectorId?: string;
}

export function AuthenticationErrorMessages({
  error,
  email,
  selectorId,
}: Props) {
  const { mutate: resendEmail, status } = useResendEmailValidation();
  const errorState = useAuthErrorMessage(error);
  const dispatch = useDispatch();

  return (
    <Notification alert data-cy-id={selectorId}>
      {errorState.type === 'generic' && (
        <Text typography="tiny" textAlign="left">
          {errorState.message}
        </Text>
      )}
      {errorState.type === 'pending' && (
        <Text typography="tiny" textAlign="left">
          {errorState.message}{' '}
          {typeof email === 'string' && (
            <Button
              styleType="softLink"
              onClick={() => resendEmail(email)}
              disabled={status === 'loading'}
              isLoading={status === 'loading'}
            >
              Resend email.
            </Button>
          )}
        </Text>
      )}
      {errorState.type === 'stale' && (
        <Text typography="tiny" textAlign="left">
          {errorState.message}{' '}
          <Button
            styleType="softLink"
            onClick={() => dispatch(redirect({ type: ROUTE_USER_REGISTER }))}
            disabled={status === 'loading'}
            isLoading={status === 'loading'}
            data-cy-id="register"
          >
            Register.
          </Button>
        </Text>
      )}
    </Notification>
  );
}
